import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {Zeitstate} from '../../../Zeiterfassung/store/reducer/zeiterfassung.reducer';
import {SpesenartItem} from '../../../Zeiterfassung/spesenart.model';
import {FirmaZeitItem} from '@src/app/pages/Mitarbeiterverwaltung/firmaZeit.model';
import {BestaetigungsFormComponent} from '@src/app/ui-components/bestaetigungs-form/bestaetigungs-form.component';
import {deleteFirmaZeitStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-del.actions';
import {FirmaZeitFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/firmazeiten-form-dialog/firmazeiten-formdialog.component';
import {FeiertagItem} from '@src/app/pages/Mitarbeiterverwaltung/feiertage.model';
import {deleteFeiertageStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/feiertage-del.actions';
import {FeiertageFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/feiertage-form-dialog/feiertage-formdialog.component';

@Component({
    selector: 'app-feiertage-table',
    templateUrl: './feiertage-table.component.html',
    styleUrls: ['./feiertage-table.component.scss'],
})
export class FeiertageTableComponent implements OnInit {
  public displayedColumns: string[] = [
    'datum',
    'bez',
    'actions',
  ];

  public dataSource = new MatTableDataSource<FeiertagItem>();

  constructor( public dialog: MatDialog , public store: Store<{ zeiterfassung: Zeitstate }> ) {
  }

  @Input()
  public showFunctionMenu = true;

  @Input()
  public zeitId: number;


  @Input()
  public set feiertage(feiertag: FeiertagItem[]) {
    this.dataSource.data = feiertag;

  }


    public ngOnInit(): void {}

  public editFeiertag(firmaZeit: FeiertagItem): void {
    const dialogRef = this.dialog.open(FeiertageFormdialogComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.firmaZeitenDialog.feiertagTitle',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.cancelButtonLabel',
        firmaZeitId: firmaZeit.firmaZeitId,
        id: firmaZeit.id,
        datum: firmaZeit.datum,
        bez: firmaZeit.bez,
      }
    });
  }

  public deleteFeiertag(feiertagItem: FeiertagItem): void {
    this.store.dispatch(deleteFeiertageStart({item: feiertagItem}));
  }


}
